import React from 'react';

const Asteric = () => {
  return <span className="astrict-sign"> *</span>;
};

export default Asteric;
